import React from 'react';
import Layout from '../layout';
import { withLocalize } from "react-localize-redux";
import ajaxService from '../services/ajax-service';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { setToken, setUser } from '../redux/actions';
import { Form, Input, Button } from 'antd-mobile';
import { useDispatch } from 'react-redux';

const Register = ({ translate }) => {

    const router = useHistory();
    const [, setLogin] = useAuth()
    const dispatch = useDispatch();

    const onFinish = async (values) => {

        let response = await ajaxService.post('register', values);

        if (response != null) {

            let { token, user } = response.data;

            setLogin(true);
            dispatch(setToken(token))
            dispatch(setUser(user))
            router.push({ pathname: '/home' })
        }

    }

    return (
        <Layout title={translate('register')} >
            <div style={{ marginLeft: '30px', marginRight: '30px', height: document.body.clientHeight }}>

                <h2 style={{
                    textAlign: 'center',
                    marginBottom: '10px',
                    color: '#333',
                    fontWeight: 'bold'
                }}>
                    {translate('only_for_masjid_admin')}

                </h2>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
                    <Form
                        onFinish={onFinish}
                        footer={
                            <Button block type='submit' color='primary' size='large'>
                                Submit
                            </Button>
                        }
                        mode="card"
                    >
                        <Form.Item
                            name='name'
                            label='Name'
                            rules={[{ required: true, message: 'Name field is required' }]}
                        >
                            <Input placeholder='Name' />
                        </Form.Item>
                        <Form.Item
                            name='email'
                            label='Email'
                            rules={[{ required: false, message: 'Email field is required' }]}
                        >
                            <Input placeholder='Email' />
                        </Form.Item>
                        <Form.Item
                            name='phone'
                            label='Phone'
                            rules={[{ required: true, message: 'Phone field is required' }]}
                        >
                            <Input placeholder='Phone' />
                        </Form.Item>
                        <Form.Item
                            name='password'
                            label='Password'
                            rules={[{ required: true, message: 'Password field is required' }]}
                        >
                            <Input placeholder='Password' type="password" />
                        </Form.Item>
                        <Form.Item
                            name='password_confirmation'
                            label='Retype Password'
                            rules={[{ required: true, message: 'Retype Password field is required' }]}
                        >
                            <Input placeholder='Password' type="password" />
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </Layout>
    )

}

export default withLocalize(Register)